import { HTTP } from "./index";
import axios from "axios";

export default {
  async getOrderByFlorist(floristID) {
    return HTTP.get("/", {
      params: {
        a: "Order.getByFlorist",
        id: floristID
      }
    });
  },

  async getOrderSpecification(orderID) {
    return HTTP.get("/", {
      params: {
        a: "Order.getSpecification",
        id: orderID
      }
    });
  },

  async productTimerStart(productID) {
    return HTTP.get("/", {
      params: {
        a: "Order.productSetTimer",
        id: productID,
        value: 1
      }
    });
  },

  async productTimerStop(productID) {
    return HTTP.get("/", {
      params: {
        a: "Order.productSetTimer",
        id: productID,
        value: 0
      }
    });
  },

  async findProduct(keyword) {
    return HTTP.get("/", {
      params: {
        a: "Product.search",
        query: keyword
      }
    });
  },

  async transferProduct(action, orderID, guid, amount) {
    return HTTP.get("/", {
      params: {
        a: "Warehouse.transfer",
        orderID,
        action,
        guid,
        amount
      }
    });
  },

  async updateComposition(composition, orderID) {
    return HTTP.post("/?a=Composition.update", {
      orderID,
      composition
    });
  },

  async getWarehouseStock(warehouses) {
    return HTTP.get("/", {
      params: {
        a: "Warehouse.stock",
        warehouses
      }
    });
  },

  async addPosition(orderID, productGuid, index, addedGuid) {
    return HTTP.get("/", {
      params: {
        a: "Composition.add",
        orderID,
        productGuid,
        index,
        addedGuid
      }
    });
  },

  async addRealization(orderID, products) {
    return HTTP.post("/?a=Order.add", {
      orderID,
      products
    });
  },

  async getMembers(query) {
    return HTTP.get("/", {
      params: {
        a: "Member.getList",
        q: query
      }
    });
  },

  async isValid(userID, pin) {
    return HTTP.get("/", {
      params: {
        a: "Member.isValid",
        userID,
        pin
      }
    });
  },

  async GetWarehouseList() {
    return HTTP.get("/", {
      params: {
        a: "Warehouse.getList"
      }
    });
  },

  async getPiggybank(floristID, cb) {
    axios({
      method: "get",
      url: `https://my.tory.ae/members/${floristID}/report/api`
    }).then(function(response) {
      cb(response.data);
    });
  },

  async setWarehouseId(id) {
    return HTTP.get("/", {
      params: {
        a: "Warehouse.setWarehouseId",
        id: id
      }
    });
  },

  async RemovePhoto(imageName) {
    return HTTP.get("/", {
      params: {
        a: "Photo.remove",
        image: imageName
      }
    });
  },

  async TgCourierNotify(text) {
    axios({
      method: "post",
      url: `https://api.telegram.org/bot1432360746:AAFha3jzrIkVC_ExDJUHP2F0QuC2_S-Lpdc/sendMessage`,
      params: {
        chat_id: "-1002312575230",
        text: text
      }
    });
  }
};
